export const staticAssetPrefix = process.env.GATSBY_STATIC_ASSET_PREFIX ?? '';
export const staticAssetPath = (path: string) => {
  if (!path?.startsWith('/')) {
    throw new Error("staticAssetPath requires a path starting with '/'");
  }
  return `${staticAssetPrefix}${path}`;
};
